/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNightLife = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m20.833 2 1.162 1.627-4.722 3.372H22l-9 9v4h4v2H7v-2h4v-4L2 7h11.834zM17 9H6.829L12 14.172z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNightLife as NightLife };
